import React from "react";
import RenderChildrenWrapper from "../../common/RenderChildrenWrapper";
import SummaryCell from "./SummaryCell/SummaryCell";
const ThreatsDetected = ({ detections, footerWrapper, }) => {
    const totalCount = detections.type.reduce((acc, detection) => acc + detection.total_count, 0);
    const worstThreat = [...detections.type].sort((first, second) => second.total_count - first.total_count)[0];
    return (React.createElement(SummaryCell, { label: "Malware found", value: totalCount.toLocaleString(), subline: React.createElement(RenderChildrenWrapper, { wrapper: footerWrapper &&
                ((children) => { var _a; return footerWrapper((_a = worstThreat === null || worstThreat === void 0 ? void 0 : worstThreat.threat_type) !== null && _a !== void 0 ? _a : null, children); }) }, totalCount > 0 ? (React.createElement("span", null,
            worstThreat.total_count.toLocaleString(),
            " ",
            worstThreat.threat_type,
            " threat",
            worstThreat.total_count !== 1 && "s")) : (React.createElement("span", null, "No evidence of malware"))) }));
};
export default ThreatsDetected;
//# sourceMappingURL=ThreatsDetected.js.map